import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './lawfirm_v2/Header';
import Footer from './lawfirm_v2/Footer';
import Home from './lawfirm_v2/Home';
import Practice from './lawfirm_v2/Practice';
import Counsel from './lawfirm_v2/Counsel';
import Inquiry from './lawfirm_v2/Inquiry';

export default function LawFirmTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#E8DCC1]" data-testid="law-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`law-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'practice' && <Practice setPage={setPage} />}
          {page === 'counsel' && <Counsel setPage={setPage} />}
          {page === 'inquiry' && <Inquiry setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
